import { TabView as PrimeTabView } from 'primereact/tabview'

/**
 * @param {import("primereact/tabview").TabViewProps} props
 */
const TabView = PrimeTabView

export default TabView
